import { LOGIN_SUCCESS, LOGOUT, UPDATE_USER_DATA } from '../constants';

const defaultState = {
  loggedIn: false,
  user: null,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case UPDATE_USER_DATA: {
      const { data } = action;

      localStorage.setItem('user', JSON.stringify(data));

      return Object.assign({}, state, {
        user: data,
      });
    }
    case LOGIN_SUCCESS: {
      const { user, token } = action.data;

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      return Object.assign({}, state, {
        loggedIn: true,
        user,
      });
    }
    case LOGOUT: {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      return Object.assign({}, state, {
        loggedIn: false,
        user: null,
      });
    }
    default: {
      return state;
    }
  }
}
